import {
  isHotel,
  isDropoff,
  getFlag
} from '../poi';
import {
  getPoiList,
  getStartTime,
  getDays,
  getPoiMap,
  getCityMap,
  getEndCity,

} from './getStatic';
import {
  setHoursByZone
} from '../../utils/formatDate';
import{
  getTitle
} from './find';


/**
 * 向行程添加城市
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} day 添加到哪天？
 * @param {any} city 城市对象
 * @returns
 */
export function addCity(trip, city, day) {
  let poiList = getPoiList(trip);
  let index = day - 1;

  // 当天的所有poi
  let pois,city_list, cityStr;
  if (poiList[index]) {
    pois = [...poiList[index].pois];
    city_list= [...poiList[index].city_list];
  } else {
    pois = [];
    city_list= [];
  }
  cityStr = city_list.map((city)=>{
    return city.city_id;
  }).join(',');

  city && (trip = addCityToMap(trip, city));

  //添加到city_list
  if(city && cityStr.indexOf(city.city) > -1){
    let _temp = [...city_list];
    _temp.forEach((item,index)=>{
      if(item.city_id === city.city){
        city_list.splice(Number(index), 1);
      }
    });
  };
  city && city_list.push({city_id: city.city});

  poiList = [...poiList];
  poiList[index] = {...poiList[index], city_list};

  trip = setPoiList(trip, poiList);

  return trip;
}

/**
 * 从行程某天移除城市，同时将会移除当天该城市下所有poi
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} day 从哪天移除？
 * @param {any} index 
 * @returns
 */
export function removeCity(trip, index, day) {
  let count = 0; // poi已安排次数

  let poiList = getPoiList(trip);
  let city_info_maps = getCityMap(trip);
  let poi_uid_map = getPoiMap(trip);
  poiList.forEach(function (item, dayIndex) {
    if(dayIndex === day - 1){
      let removeCity = item.city_list.filter((city, cityIndex)=>{
        return index === cityIndex;
      })[0].city_id;
      item.pois = item.pois.filter((poi)=>{
        let poiCity = poi_uid_map[poi.poi_uid].info.city;
        return poiCity !== removeCity;
      });

      item.city_list = item.city_list.filter((city)=>{
        return removeCity !== city.city_id;
      });
    }
  });

  trip = setPoiList(trip, poiList);
  return trip;
}


/**
 * 向行程添加poi
 *
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} poi 被添加的poi对象
 * @param {any} day 添加到哪天？
 * @param {any} city poi关联的城市对象  
 * @returns
 */
export function addPoi(trip, poi, day, city) {
  let poiList = getPoiList(trip);
  let index = day - 1;

  // 当天的所有poi
  let pois,city_list, cityStr;
  if (poiList[index]) {
    pois = [...poiList[index].pois];
    city_list= [...poiList[index].city_list];
  } else {
    pois = [];
    city_list= [];
  }
  cityStr = city_list.map((city)=>{
    return city.city_id;
  }).join(',');

  // 默认插入最后，但必须在酒店和还车门店之前
  let insertPoint = pois.length;
  let lastPoi = pois[insertPoint - 1];
  let deleteCount = 0;
  /* 
    如果当前插入的为非酒店类型， 最后一个poi是“酒店”或“还车门店”，插到倒数第二，否则插入最后，
    如果是酒店类型，最后一个poi是“酒店”或“还车门店”，替换酒店
  */ 
  if (lastPoi) {
    if(!isHotel(poi.poi_uid)){
      // 最后一个点是还车点，
      //  - 且有酒店，插入酒店之前；
      //  - 没有酒店，则插入还车点之前
      // 最后一个点是酒店，插入酒店之前；
      if(isHotel(lastPoi.poi_uid)){
        insertPoint--;
      }else if(isDropoff(lastPoi.poi_uid)){
        if(insertPoint > 1 && isHotel(pois[insertPoint - 2].poi_uid)){
          insertPoint = insertPoint - 2;
        }else{
          insertPoint--;
        }
      }
    }else{
      // 最后一个点是还车点，
      //  - 且有酒店，替换最后一个酒店；
      //  - 没有酒店，则插入酒店
      // 最后一个点是酒店，替换最后一个酒店；
      if(isDropoff(lastPoi.poi_uid)){ 
        if(insertPoint > 1 && (isHotel(pois[insertPoint - 2].poi_uid))){
          pois.splice(insertPoint - 2, 1);
          insertPoint = insertPoint - 2;
        }else{
          insertPoint--;
        }
      }else if(isHotel(lastPoi.poi_uid)){
        pois.splice(insertPoint - 1, 1);
      }
    }
  }

  
  pois.splice(insertPoint, deleteCount, {
    poi_uid: poi.poi_uid,
    flag: getFlag(poi)
  });

  // 将poi和city添加到map中
  trip = addPoiToMap(trip, poi);

  city && (trip = addCityToMap(trip, city));

  //添加到city_list 
  // if(city && cityStr.indexOf(city.city) > -1){
  //   let _temp = [...city_list];
  //   _temp.forEach((item,index)=>{
  //     if(item.city_id === city.city){
  //       city_list.splice(Number(index), 1);
  //     }
  //   });
  // };
  // city && city_list.push({city_id: city.city});
  if(city && cityStr.indexOf(city.city) === -1){
    city_list.push({city_id: city.city});
  }



  poiList = [...poiList];
  poiList[index] = {...poiList[index], pois, city_list};

  trip = setPoiList(trip, poiList);

  return trip;
}



/**
 * 从行程移除poi
 *
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} poi_uid 被移除的poi对象的poi_uid
 * @param {any} day 移除哪天的？
 * @returns
 */
export function removePoi(trip, poi_uid, day) {
  let count = 0; // poi已安排次数

  let poiList = getPoiList(trip);
  poiList.forEach(function (item, dayIndex) {
    item.pois = item.pois.filter(function (poi) {
      if (poi.poi_uid === poi_uid) {
        count++;

        // day不为0，且非day那一天，不删除
        if (day && day - 1 !== dayIndex) {
          return true;
        }
        count--;
        return false;
      }
      return true;
    });
  });

  trip = setPoiList(trip, poiList);
  trip.poi_uid_map = {...trip.poi_uid_map};

  if (count === 0) {
    delete trip.poi_uid_map[poi_uid];
  }

  return trip;
}

/**
 * 排序行程的poi顺序
 *
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} newIndexs 排序后的索引顺序
 * @param {any} day 排序哪天？
 * @returns
 */
export function sortPois(trip, newIndexs, day) {
  let poiList = getPoiList(trip);
  let index = day - 1;

  let pois = poiList[index].pois;
  poiList[index].pois = newIndexs.map(function (item) {
    let index = parseInt(item, 10);
    return pois[index];
  });

  trip = setPoiList(trip, poiList);

  return trip;
}


/**
 * 检查能否添加poi
 * 能
 * @return {bool} true
 * 不能
 * @return {object} { message, code }
 */
export function checkAddPoi(trip, poi, day) {
  let poiList = getPoiList(trip);
  let index = day - 1;

  // 当天的所有poi
  let pois;
  if (poiList[index]) {
    pois = [...poiList[index].pois];
  } else {
    pois = [];
  }

  // 若已经添加，则不再添加
  for (let i in pois) {
    if (pois[i].poi_uid === poi.poi_uid) {
      return {
        message: `${poi.info.cn_name}已在这一天行程安排中，无需重复添加`,
        code: 0
      };
    }
  }

  // 若当天已有酒店，不再添加酒店
  if (isHotel(poi)) {
    for (let i in pois) {
      if (isHotel(pois[i])) {
        return {
          message: '当天已添加酒店，无需重复添加',
          code: 1
        };
      }
    }
  }

  return true;
}

/**
 * 更新poi信息 -- 暂时只适用于自定义poi
 * 先remove 再add
 * 因为更新的时候poi的城市有可能变化了
 * 我发现这个坑大了
 * @param {*} trip 
 * @param {*} poi poi完整信息
 * @param {*} day 
 * @param {*} city  city完整信息
 */
export function updatePoi(trip, poi, day, city ) {
  let poiList = getPoiList(trip);
  let index = day - 1;

  // 当天的所有poi
  let pois,city_list;
  if (poiList[index]) {
    pois = [...poiList[index].pois];
    city_list= [...poiList[index].city_list];
  } else {
    pois = [];
    city_list= [];
  }
  

  //添加到city_list 
  let poi_uid_map = getPoiMap(trip);
  city_list = [];
  pois.forEach((item, index)=>{
    let cityId = poi_uid_map[item.poi_uid].info.city;
    if(item.poi_uid === poi.poi_uid){
      cityId = city.city;
    }
    
    //城市只需要按次序排就行，需要去重
    let cityStr = city_list.map((city)=>{
      return city.city_id;
    }).join(',');

    if(cityId && cityStr.indexOf(cityId) === -1){
      city_list.push({city_id: cityId});
    }

    //这是途径城市，不去重，完全按照poi的游玩次序走
    // let prevCity = (city_list && city_list.length && city_list[index-1].city_id) || '';
    // if(cityId && prevCity !== cityId){
    //   city_list.push({city_id: cityId});
    // }

    
  });
 
  // 将poi和city添加到map中
  trip = addPoiToMap(trip, poi);

  city && (trip = addCityToMap(trip, city));


  poiList = [...poiList];
  poiList[index] = {...poiList[index], pois, city_list};

  trip = setPoiList(trip, poiList);


  return trip;
}




/**
 * 设置开始时间
 *
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} time 开始时间的时间戳
 * @returns
 */
export function setStartTime(trip, time) {

  // 强制转换成当前日数中国时间的9点
  time = setHoursByZone(time * 1000, 9, 8);console.log('start:', new Date(time));
  time = parseInt(time / 1000, 10);

  trip = {...trip, start_time: time};
  trip = resetDaysDate(trip, time);

  // 根据trip_days，设置end_time
  let days = getDays(trip);
  let endTime = parseInt(time + (days - 1) * 86400, 10);

  trip = setEndTime(trip, endTime, false);

  return trip;
}

/**
 * 设置结束时间
 *
 * @export
 * @param {any} trip 目标行程对象
 * @param {any} time 结束时间的时间戳
 * @returns
 */
export function setEndTime(trip, time, changeDyas = true) {
  // 21点，注意，当前时间输入已经是针对+8时区的时间
  time = setHoursByZone(time * 1000, 21, 8, 8);console.log('end:', new Date(time));
  time = parseInt(time / 1000, 10);

  trip = {...trip, end_time: time};

  if (changeDyas) {
    // 根据开始时间和结束时间重置天数
    let startTime = getStartTime(trip);
    let days = (time - startTime) / 60 / 60 / 24;
    days = Math.ceil(days);
    trip = setDays(trip, days, false);
  }

  return trip;
}


export function resetDaysDate(trip, time) {
  let oldDays = trip.poi_list,
    newDays = [],
    startDate = time * 1000,
    date;

  if(oldDays){
    oldDays.forEach((day, index) => {
      date = setHoursByZone(startDate + index * 86400000, 9, 8, 8);
  
      newDays.push({
        ...day,
        date: date / 1000,
      });
    });  
  }
  
  trip = {
    ...trip,
    poi_list: newDays
  };

  return trip;
}



/**
 * 增加一天
 * city_list 默认为endcity
 *
 * dayObj为可选参数，覆盖默认day对象
 * @param {*} trip
 * @param {*} dayObj 可选
 */
export function addOneDay(trip, dayObj) {
  let poiList = getPoiList(trip);
  let days = poiList.length + 1;
  let endCityList = poiList[poiList.length - 1].city_list;
  let endCity = endCityList[endCityList.length-1].city_id || getEndCity(trip).city;
  let newDay = {
    day: days,
    pois: [],
    city_list: [{city_id: endCity}]
  };

  newDay = { ...newDay, ...dayObj};
  // 设置新加的这天的时间 拿最后一天的时间加
  if (trip.start_time) {
    newDay.date = trip.start_time;
    if (poiList && poiList.length) {
      newDay.date = poiList[poiList.length - 1].date + 86400;
    }
  }

  poiList = poiList.concat(newDay);

  trip = {
    ...trip,
    poi_list: poiList
  };

  trip = setDays(trip, days);
  trip = fixPickupAndDropoff(trip);

  return trip;
}





/**
 * 删除一天
 * @param {*} trip
 * @param {*} day (第几天)
 */
export function deleteOneDay(trip, day) {
  let poiList = getPoiList(trip);

  let newIndexs = poiList.map((v, i) => i);
  newIndexs.splice(day - 1, 1);

  trip = sortDay(trip, newIndexs);

  trip = {...trip};

  trip = setDays(trip, newIndexs.length);
  trip = fixPickupAndDropoff(trip);

  return trip;
}


/**
 *  排序poi
 * @param {*} trip
 * @param {*} newIndexs  (数组排序后的索引列表)
 */
export function sortDay(trip, newIndexs) {
  let days = getPoiList(trip);

  let oldDay, newDay, newDays = [];

  newIndexs && newIndexs.forEach((oldIndex, newIndex) => {
    // oldDay只保留时间相关的：day, dsate
    oldDay = days[newIndex]; // 换之前的day对象
    newDay = days[oldIndex]; // 将要换上来的day对象

    newDays.push({
      ...newDay,
      // 保留旧对象时间、顺序相关的字段
      day: oldDay.day,
      date: oldDay.date,
      dateStr: oldDay.dateStr,
    });
  });

  trip = setPoiList(trip, newDays);
  trip = fixPickupAndDropoff(trip);

  return trip;
}

// 取还车点固定行程头尾，无论怎样编辑天
function fixPickupAndDropoff(trip) {
  let { pickup, dropoff, poi_list } = trip;

  if (!pickup && !dropoff) return trip;

  // 遍历，删除，再添加到头尾
  let pickupUid = pickup && pickup.poi_uid,
    dropoffUid = dropoff && dropoff.poi_uid;

  poi_list.forEach((day, dayIndex) => {
    let pois = day.pois,
      len = pois.length;
    for (let i = len - 1; i >= 0; i--) {
      if (pois[i].poi_uid === pickupUid || pois[i].poi_uid === dropoffUid) {
        pois.splice(i, 1);
      }
    }

    if (dayIndex === 0 && pickup) {
      pois.unshift({
        poi_uid: pickupUid,
        flag: 'pickup'
      });
    }

    if (dayIndex === poi_list.length - 1 && dropoff) {
      pois.push({
        poi_uid: dropoffUid,
        flag: 'dropoff'
      });
    }

    day.pois = pois;
  });

  return trip;
}


// 设置天数 参数：days(总天数)
export function setDays(trip, days, changeEndTime = true) {
  trip = {...trip, trip_days: days, days};

  let startTime = getStartTime(trip);
  if (changeEndTime && startTime) {
    // setStartTime包含了设置endTime的逻辑
    trip = setStartTime(trip, startTime);
  }

  trip.trip_name = getTitle(trip,true);

  return trip;
}

function setPoiList(trip, poiList) {
  trip = {...trip, poi_list: poiList};

  return trip;
}



function setPoiMap(trip, poiMap) {
  trip = {
    ...trip,
    poi_uid_map: poiMap
  };

  return trip;
}



function setCityMap(trip, cityMap) {
  trip = {
    ...trip,
    city_info_maps: cityMap
  };

  return trip;
}


function addCityToMap(trip, city) {
  let cityMap = getCityMap(trip);
  let key = city.city + '';

  cityMap = {...cityMap};
  cityMap[key] = city;

  return setCityMap(trip, cityMap);
}

function addPoiToMap(trip, poi) {
  let poiMap = getPoiMap(trip);
  let key = poi.poi_uid;

  poiMap = {...poiMap};
  poiMap[key] = poi;

  return setPoiMap(trip, poiMap);
}

// 根据poi对象数组获取线路城市
export function getCitiesByPois(trip, pois) {
  let cityMap = trip.city_info_maps || {},
    cities = [],
    cityId,
    preCityId;

  pois.forEach(poi => {
    cityId = poi.info.city;
    if (cityMap[cityId]) {
      if (cityId != preCityId) {// 去重
        cities.push(cityMap[cityId]);
        preCityId = cityId;
      }
    } else {
      console.warn('city', cityId, 'is missed in cityMap');
    }
  });

  return cities;
}

/**
 * 删除poi(非hotel)
 * day参数可选，选择对应天删除，否则全程删除
 */
export function deletePoi(trip, poiUid, day) {
  let count = 0; // poi已安排次数

  let poiList = getPoiList(trip);
  poiList.forEach(function (item, dayIndex) {
    item.pois = item.pois.filter(function (poi) {
      if (poi.poi_uid === poiUid) {
        count++;

        // day不为0，且非day那一天，不删除
        if (day && day - 1 != dayIndex) {
          return true;
        }
        count--;
        return false;
      }
      return true;
    });
  });

  trip = setPoiList(trip, poiList);
  trip.poi_uid_map = {...trip.poi_uid_map};

  if (count === 0) {
    delete trip.poi_uid_map[poiUid];
  }

  return trip;
}



// WEBPACK FOOTER //
// ./src/helpers/trip/modify.js